


































































































import Vue from 'vue'
import { mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email } from 'vuelidate/lib/validators'
import {EntityService} from "@/services/entity.service";
const entityService = new EntityService()

export default Vue.extend({
	name: 'Login',
	mixins: [validationMixin],
	validations: {
		email: {email, required},
		password: {required}
	},
	data: () => ({
		entity: 'users',
		email: '',
		password: '',
		code: '',
		newPassword: '',
		step: 1
	}),
	created() {
		// console.log('isLoggedIn: ' + this.isLoggedIn)
	},
	methods: {
		loginClick: async function () {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				this.$store.commit("CHANGE_LOADING", true)
				await this.$store.dispatch("login", {email: this.email, password: this.password})
				this.$store.commit("CHANGE_LOADING", false)
			}
		},
		recovery: async function () {
			try {
				this.isLoading = true
				const data = {
					'email': this.email
				}
				await entityService.makeAction(this.entity, 'recovery',data)
				this.code = ''
				this.newPassword = ''
				this.step = 3
			} catch (e) {
				alert(e.message)
			} finally {
				this.isLoading = false
			}
		},
		changePassword: async function () {
			try {
				this.isLoading = true
				const data = {
					'email': this.email,
					'code': this.code,
					'password': this.password
				}
				await entityService.makeAction(this.entity, 'changepassword',data)
				this.code = ''
				this.newPassword = ''
				this.step = 1
			} catch (e) {
				alert(e.message)
			} finally {
				this.isLoading = false
			}
		},
		getError: function (element: string) {
			if (this.$v[element].$error) return 'Invalid'
			return;
		}
	},
	computed: {
		...mapGetters([
			'isLoading', 'isLoggedIn'
		])
	},
	watch: {
		isLoggedIn: function (isLoggedIn) {
			if (isLoggedIn === true) this.$router.replace({name:'AudiosList'})
		}
	}
})
